module.exports = __webpack_public_path__ + "static/media/S1-11-Jyrgozz-cod11.d8c44578.png";